import type { Framework } from '@toeverything/infra';

import { DefaultServerService } from '../cloud';
import { DocsService } from '../doc';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { AccountTemplateList } from './entities/list';
import { AccountTemplateService } from './services/account-template';
import { AccountTemplateTransferService } from './services/account-template-transfer';
import { AccountTemplateContentStore } from './store/content';
import { AccountTemplateListStore } from './store/list';

export { AccountTemplateService, AccountTemplateTransferService };
export {
  TemplateLimitReachedError,
  TemplateTooLargeError,
} from './services/account-template-transfer';
export type { AccountTemplateMeta, PublishResult } from './type';

export const configureAccountTemplateModule = (framework: Framework) => {
  framework
    .store(AccountTemplateListStore, [DefaultServerService])
    .store(AccountTemplateContentStore, [DefaultServerService])
    .entity(AccountTemplateList, [AccountTemplateListStore])
    .service(AccountTemplateService, [
      AccountTemplateListStore,
      AccountTemplateContentStore,
    ])
    .scope(WorkspaceScope)
    .service(AccountTemplateTransferService, [
      AccountTemplateService,
      DocsService,
      WorkspaceService,
    ]);
};
